import numeral from "numeral";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "semantic-ui-react";
import { MostrarPopup } from "../Reducers/PopupReducer";
import { ColocarOrden } from "../Pages/ColocarOrden";

export const RowRender = (params) => {

    const dispatch = useDispatch();

    const { Item } = params;
    const [internalState, setInternalState] = useState({
        Open: false
    })

    const OnClick = () => { if (params.onClick) { params.onClick(Item); } }
    const _perdidaGanancia = +Item.TotalMXN - (+params.Inversion);


    const OnClickColocarOrden = async () => {
        // debugger
        dispatch(MostrarPopup({
            Titulo: `Colocar Orden`,
            Content: (<ColocarOrden
                MonedaDetalle={params.MonedaDetalle}
            />),
            Cerrar: (r) => { }
        }))
    }

    return (<>
        <div className="tbl-cripto-item" onClick={() => { OnClick(); }}>
            <div className="row1">
                <div className={`l-${Item.Clave}`}>{Item.Nombre}</div>
                <div>{numeral(Item.UltimoPrecio).format("0,000.00")}</div>
            </div>
            <div className="row2">
                <div>{numeral(Item.Total).format("0,000.00000000")}</div>
                <div>{numeral(Item.TotalMXN).format("0,000.00")} MXN</div>
            </div>
            {
                +params.Inversion !== 0 && (<>
                    <div className="row2" >
                        <div>Inversion</div>
                        <div>{numeral(params.Inversion).format("0,000.00")} MXN </div>
                    </div>
                    <div className="row2">
                        <div>Perdida / Ganancia</div>
                        <div className={`${_perdidaGanancia > 0 ? "compra" : "venta"}`}>{numeral(_perdidaGanancia).format("0,000.00")} MXN </div>
                    </div>
                </>)
            }
            {
                params.AgregarOrden && (<>
                    <div className="row2">
                        <div onClick={() => { OnClickColocarOrden(); }} ><Icon name="plus" /> Agregar Orden</div>
                        <div></div>
                    </div>
                </>)
            }
            {
                Item.Clave === "mxn" && (<>
                    <div className="row2" style={{ paddingTop: "10px" }}>
                        <div>Disponible</div>
                        <div>{numeral(Item.Disponible).format("0,000.00")} {Item.Clave} </div>
                    </div>
                    <div className="row2">
                        <div>Reservado</div>
                        <div>{numeral(Item.Reservado).format("0,000.00")} {Item.Clave}</div>
                    </div>
                </>)
            }
        </div>
    </>)
}
RowRender.defaultProps = {
    Inversion: 0
}